<button [class.--disable]="hasReachedLastPage()" pdsButton="primary" (click)="onClickLoadMore()">Carregar mais</button>
